import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { FaInstagram, FaRegRegistered } from 'react-icons/fa';
import { FiFacebook } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NewFormWizard from '../../../../components/formWizard/NewFormWizard';
import NewFormWizardChild from '../../../../components/formWizard/NewFormWziardChild';
import Layout from '../../../../components/layouts/Layout'
import { LoadingSpinner } from '../../../../components/Loader/Loader';
import http from '../../../../config/BaseUrl';
import { eventSocial } from '../slice/createEventSlice'

const SocialMedia = () => {

    const dispatch = useDispatch()
    const history = useHistory()
    // const eventId = history.location.state
    const { event_option, social, eventId } = useSelector(state => state.createEvent)

    const [instagramToggle, setInstagramToggle] = useState(true);
    const InstagramToggle = () => setInstagramToggle(!instagramToggle)
    const [facebookToggle, setFacebookToggle] = useState(false);
    const FacebookToggle = () => setFacebookToggle(!facebookToggle)
    const [socialDetails, setSocialDetails] = useState("")
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)

    const { register, handleSubmit } = useForm({
        mode: 'all',
        defaultValues: {
            email_message: social.email_message
        }

    })

    const handelSocial = async (data) => {

        const socialEvent = {
            instagram: instagramToggle,
            client_facebook: facebookToggle,
            email_message: data.email_message
        }

        dispatch(eventSocial(socialEvent))
        setLoading(true)
        await http.post("social-media", { ...data, instagramToggle, facebookToggle, eventId }).then((res => {
            setLoading(false)
            if (event_option) {
                    if  (event_option.gif               === true) { history.push('/event/gif', eventId) }
                else if (event_option.brust_gif         === true) { history.push('/event/brust-gif', eventId) }
                else if (event_option.email             === true) { history.push('/event/email', eventId) }
                else if (event_option.text_messaging    === true) { history.push('/event/sms', eventId) }
                else if (event_option.digital_props     === true) { history.push('/event/digital-prop', eventId) }
                else if (event_option.water_mark        === true) { history.push('/event/custom-branding', eventId) }
                else if (event_option.microsite         === true) { history.push('/event/microsite', eventId) }
                else if (event_option.frame_option      === true) { history.push('/event/frame', eventId) }
                else if (event_option.incentive_offer   === true) { history.push('/event/incentive-offer', eventId) }
                else if (event_option.filters           === true) { history.push('/event/filter', eventId) }
                else if (event_option.form_builder === true) { history.push('/event/form-builder', eventId) }
                else { history.push('/event/summary', eventId) }
            }
        })).catch(err => err.response.data.message)
    }

    const saveAsDraft = () => {
        handleSubmit(async (data) => {
            const socialEvent = {
                instagram: instagramToggle,
                client_facebook: facebookToggle,
                email_message: data.email_message
            }

            dispatch(eventSocial(socialEvent))
            setDraftLoading(true)
            await http.post("social-media", { ...data, instagramToggle, facebookToggle, eventId }).then((res => {
                setDraftLoading(false)

            })).catch(err => {
                setDraftLoading(false)
            })

        })()
    }
    const BackToPreviousPage = (e) => {
        e.preventDefault()
        history.push('/event/options')
    }
    return (
        <Layout>
            <NewFormWizard />
            <NewFormWizardChild />
            <section className="mt-5">
                <form onSubmit={handleSubmit(handelSocial)}>
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="text-center col-12 col-ma-12">
                                            <div className="pb-4">
                                                <p className="mb-0 display-4 text-primary event-form-title">Social</p>
                                                <p className="mb-0 text-secondary">All your social account settings</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="my-3 row">
                               {/*          <div className="col-md-12">
                                            <div className="p-1 bg-white border radius-10">
                                                <textarea
                                                    className="form-control"
                                                    id=""
                                                    cols="30"
                                                    rows="3"
                                                    {...register("email_message")}
                                                    disabled={!instagramToggle}
                                                    value="Follow us on Instagram so you can get all of our latest offers and promos"

                                                >
                                                </textarea>
                                            </div>
                                        </div> */}
                                        {/* <div className="col-md-4">
                                            <div onClick={InstagramToggle} className={`${instagramToggle === true ? 'active-primary' : ''} text-center cursor-pointer p-4 bg-white border radius-10`}>
                                                <p className="px-1 py-2 mb-0 font-size-14"><FaInstagram size={18} /> Instagram Text {instagramToggle === false ? 'Disable' : 'Enable'}</p>
                                            </div>

                                        </div> */}
                                    </div>

                                    <div className="my-3 row">
                                        <div className="col-md-8">
                                            <div className="p-1 bg-white border radius-10">
                                                <textarea
                                                    className="form-control"
                                                    id=""
                                                    cols="30"
                                                    rows="3"
                                                    value="Make sure you've liked us on Facebook so you can get all of our latest offers and promos"
                                                    disabled={!facebookToggle}
                                                >
                                                </textarea>
                                            </div>
                                        </div>
                                        <div className="col-md-4">

                                            <div onClick={FacebookToggle} className={`${facebookToggle === true ? 'active-primary' : ''} text-center cursor-pointer p-3 bg-white border radius-10`}>
                                                <p className="px-1 py-3 mb-0 font-size-14"> <FiFacebook size={18} /> Facebook Text {facebookToggle === false ? 'Disable' : 'Enable'} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="button" onClick={BackToPreviousPage} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                            {loading ?
                                (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                </button>)
                                : <button type="submit" disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                            }
                            {
                                loading ?
                                    (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                                        <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                    </button>)
                                    :
                                    <button type="button" onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                            }
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default SocialMedia
